const getExistingGifts = (items, toAddHandle) =>
  items.filter(item => item.handle == toAddHandle);

const updateCart = (updates, cb) => {
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    dataType: "json",
    data: { updates: updates }
  }).done(cb);
};

const cartTotalWithoutGifts = (items, toAddHandle) => {
  return items
    .filter(item => item.handle != toAddHandle)
    .reduce((acc, item) => {
      return item.line_price + acc;
    }, 0);
};

const cartQuantityWithoutGifts = (items, toAddHandle) => {
  return items
    .filter(item => item.handle != toAddHandle)
    .reduce((acc, item) => {
      return item.quantity + acc;
    }, 0);
};

const handleQuantityThreshold = (
  items,
  toAddVariantId,
  toAddHandle,
  quantityThreshold,
  cb
) => {
  const giftQShouldBe =
    cartQuantityWithoutGifts(items, toAddHandle) >= quantityThreshold ? 1 : 0;
  const existingGifts = getExistingGifts(items, toAddHandle);
  const existingGiftsQuantity = existingGifts.reduce((acc, item) => {
    return acc + item.quantity;
  }, 0);

  if (existingGifts.length > 0) {
    toAddVariantId = existingGifts[0].variant_id;
  }

  if (existingGifts.length != giftQShouldBe) {
    const updates = {};
    updates[toAddVariantId] = giftQShouldBe;

    updateCart(updates, cb);
  }
};

const handleTotalThreshold = (
  items,
  toAddVariantID,
  toAddHandle,
  totalThreshold1,
  totalThreshold2,
  totalThreshold3,
  cb
) => {
  const getGiftQShouldBe = total => {
    return total >= totalThreshold3
      ? 3
      : total >= totalThreshold2
      ? 2
      : total >= totalThreshold1
      ? 1
      : 0;
  };
  const giftQShouldBe = getGiftQShouldBe(
    cartTotalWithoutGifts(items, toAddHandle)
  );
  const existingGifts = getExistingGifts(items, toAddHandle);
  const existingGiftsQuantity = existingGifts.reduce((acc, item) => {
    return acc + item.quantity;
  }, 0);
  const updates = {};

  if (existingGifts.length > 0) {
    toAddVariantID = existingGifts[0].variant_id;
    let toRemoveVariantIDs = existingGifts.map(item => item.variant_id);
    toRemoveVariantIDs.forEach(varID => (updates[varID] = 0));
  }

  if (existingGiftsQuantity > giftQShouldBe) {
    // remove all gifts first
    updates[toAddVariantID] = 0;
    updateCart(updates, cb);
  } else if (existingGiftsQuantity < giftQShouldBe) {
    updates[toAddVariantID] = giftQShouldBe;
    updateCart(updates, cb);
  }
};

const handleRequiresCollection = (
  items,
  requiredCollectionProducts,
  toAddVariantId,
  toAddHandle,
  requiredCollectionTotal,
  cb
) => {
  const existingGifts = getExistingGifts(items, toAddHandle);
  const existingGiftsCount = existingGifts.reduce((acc, item) => {
    return acc + item.quantity;
  }, 0);
  const collectionProductIds = requiredCollectionProducts.map(prod => prod.id);
  const actualCollectionTotal = items
    .filter(item => collectionProductIds.includes(item.product_id))
    .reduce((acc, item) => {
      return acc + item.line_price;
    }, 0);
  // const shouldHaveGiftsCount = Math.floor(actualCollectionTotal / requiredCollectionTotal)
  // Set shouldHaveGiftsCount to 1 for now
  const shouldHaveGiftsCount =
    actualCollectionTotal >= requiredCollectionTotal ? 1 : 0;
  const updates = {};

  if (shouldHaveGiftsCount > 0 && existingGiftsCount < shouldHaveGiftsCount) {
    const variant =
      existingGifts.length > 0 ? existingGifts[0].variant_id : toAddVariantId;
    updates[variant] = shouldHaveGiftsCount;
    updateCart(updates, cb);
  } else if (existingGiftsCount > shouldHaveGiftsCount) {
    items
      .filter(item => item.handle == toAddHandle)
      .forEach(item => {
        updates[item.variant_id] = 0;
      });
    updateCart(updates, cb);
  }
};

const handleEnsureLimits = (SL, existingItems, updateCartUI) => {
  const updates = {};
  let limit;

  for (const item of existingItems) {
    limit = SL.limits.find(lim => lim.toLimitHandle == item.handle);
    if (item.quantity > limit.quantityLimit) {
      updates[item.variant_id] = limit.quantityLimit;
    }
  }
  if (Object.keys(updates).length != 0) {
    updateCart(updates, updateCartUI);
  }
};

export default {
  handleQuantityThreshold,
  handleTotalThreshold,
  handleRequiresCollection,
  handleEnsureLimits
};
